"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var enums_1 = require("./enums");
exports.challengeInitialState = {
    challenge: undefined,
    challengePayload: undefined,
    onClose: undefined,
    onSuccess: undefined,
    workflow: undefined
};
exports.initState = function () {
    return exports.challengeInitialState;
};
exports.challengeReducer = function (state, action) {
    switch (action.type) {
        case enums_1.RiskActions.PhoneEmailVerify:
            return __assign(__assign({}, state), { challenge: enums_1.RiskActions.PhoneEmailVerify, challengePayload: action.payload, workflow: action.workflow });
        case enums_1.RiskActions.PaymentCardNotVerified:
            return __assign(__assign({}, state), { challenge: enums_1.RiskActions.PaymentCardNotVerified, challengePayload: action.payload, workflow: action.workflow });
        case enums_1.RiskActions.VerificationRequired:
            return __assign(__assign({}, state), { challenge: enums_1.RiskActions.VerificationRequired, challengePayload: action.payload, workflow: action.workflow });
        case enums_1.RiskActions.RegisterCallback:
            return __assign(__assign({}, state), { onClose: action.onClose, onSuccess: action.onSuccess });
        case enums_1.RiskActions.Reset:
            return __assign({ onSuccess: state.onSuccess }, exports.challengeInitialState);
        default:
            return __assign({}, state);
    }
};
